const EMPTY_PARAMETERS = Object.freeze(Object.create(null));
export class Messages {
    translator;
    constructor(translator) {
        this.translator = translator;
    }
    ADD_CHILD_AGE_LABEL() {
        return this.translator.translate('ADD_CHILD_AGE_LABEL', EMPTY_PARAMETERS);
    }
    ADD_CHILD_AGE_MISSING() {
        return this.translator.translate('ADD_CHILD_AGE_MISSING', EMPTY_PARAMETERS);
    }
    ADD_CHILD_AGE_PLACEHOLDER() {
        return this.translator.translate('ADD_CHILD_AGE_PLACEHOLDER', EMPTY_PARAMETERS);
    }
    ADD_CHILD_CHOOSE_ONE() {
        return this.translator.translate('ADD_CHILD_CHOOSE_ONE', EMPTY_PARAMETERS);
    }
    ADD_CHILD_FAMILY_CHANGED() {
        return this.translator.translate('ADD_CHILD_FAMILY_CHANGED', EMPTY_PARAMETERS);
    }
    ADD_CHILD_FAMILY_FULL() {
        return this.translator.translate('ADD_CHILD_FAMILY_FULL', EMPTY_PARAMETERS);
    }
    ADD_CHILD_FIRST_NAME_LABEL() {
        return this.translator.translate('ADD_CHILD_FIRST_NAME_LABEL', EMPTY_PARAMETERS);
    }
    ADD_CHILD_FIRST_NAME_TOO_LONG() {
        return this.translator.translate('ADD_CHILD_FIRST_NAME_TOO_LONG', EMPTY_PARAMETERS);
    }
    ADD_CHILD_FREE_TIME_LABEL() {
        return this.translator.translate('ADD_CHILD_FREE_TIME_LABEL', EMPTY_PARAMETERS);
    }
    ADD_CHILD_HINT() {
        return this.translator.translate('ADD_CHILD_HINT', EMPTY_PARAMETERS);
    }
    ADD_CHILD_INTEREST_LABEL() {
        return this.translator.translate('ADD_CHILD_INTEREST_LABEL', EMPTY_PARAMETERS);
    }
    ADD_CHILD_INTEREST_MISSING() {
        return this.translator.translate('ADD_CHILD_INTEREST_MISSING', EMPTY_PARAMETERS);
    }
    ADD_CHILD_LEARNING_LABEL() {
        return this.translator.translate('ADD_CHILD_LEARNING_LABEL', EMPTY_PARAMETERS);
    }
    ADD_CHILD_LEARNING_MISSING() {
        return this.translator.translate('ADD_CHILD_LEARNING_MISSING', EMPTY_PARAMETERS);
    }
    ADD_CHILD_NOT_IN_LIST() {
        return this.translator.translate('ADD_CHILD_NOT_IN_LIST', EMPTY_PARAMETERS);
    }
    ADD_CHILD_SUBMIT() {
        return this.translator.translate('ADD_CHILD_SUBMIT', EMPTY_PARAMETERS);
    }
    ADD_CHILD_TIME_ZONE_REFUSED() {
        return this.translator.translate('ADD_CHILD_TIME_ZONE_REFUSED', EMPTY_PARAMETERS);
    }
    ADD_CHILD_TITLE() {
        return this.translator.translate('ADD_CHILD_TITLE', EMPTY_PARAMETERS);
    }
    ADD_CHILD_UNAVAILABLE() {
        return this.translator.translate('ADD_CHILD_UNAVAILABLE', EMPTY_PARAMETERS);
    }
    AGE_OPTION_10_OR_OLDER() {
        return this.translator.translate('AGE_OPTION_10_OR_OLDER', EMPTY_PARAMETERS);
    }
    AGE_OPTION_4() {
        return this.translator.translate('AGE_OPTION_4', EMPTY_PARAMETERS);
    }
    AGE_OPTION_5() {
        return this.translator.translate('AGE_OPTION_5', EMPTY_PARAMETERS);
    }
    AGE_OPTION_6() {
        return this.translator.translate('AGE_OPTION_6', EMPTY_PARAMETERS);
    }
    AGE_OPTION_7() {
        return this.translator.translate('AGE_OPTION_7', EMPTY_PARAMETERS);
    }
    AGE_OPTION_8() {
        return this.translator.translate('AGE_OPTION_8', EMPTY_PARAMETERS);
    }
    AGE_OPTION_9() {
        return this.translator.translate('AGE_OPTION_9', EMPTY_PARAMETERS);
    }
    CHAT_BUTTON_TEXT(name) {
        return this.translator.translate('CHAT_BUTTON_TEXT', { name });
    }
    CHILD_AGE(age) {
        return this.translator.translate('CHILD_AGE', { age });
    }
    CHILD_FREE_TIME(freeTime) {
        return this.translator.translate('CHILD_FREE_TIME', { freeTime });
    }
    CHILD_HOME_FAILED() {
        return this.translator.translate('CHILD_HOME_FAILED', EMPTY_PARAMETERS);
    }
    CHILD_HOME_GREETING(firstName) {
        return this.translator.translate('CHILD_HOME_GREETING', { firstName });
    }
    CHILD_HOME_GREETING_NO_NAME() {
        return this.translator.translate('CHILD_HOME_GREETING_NO_NAME', EMPTY_PARAMETERS);
    }
    CHILD_HOME_LESSON_FAILED() {
        return this.translator.translate('CHILD_HOME_LESSON_FAILED', EMPTY_PARAMETERS);
    }
    CHILD_HOME_LESSON_LINE(number, world, host) {
        return this.translator.translate('CHILD_HOME_LESSON_LINE', { number, world, host });
    }
    CHILD_HOME_LESSON_NUMBER(number) {
        return this.translator.translate('CHILD_HOME_LESSON_NUMBER', { number });
    }
    CHILD_HOME_LOADING() {
        return this.translator.translate('CHILD_HOME_LOADING', EMPTY_PARAMETERS);
    }
    CHILD_HOME_NO_CHILD() {
        return this.translator.translate('CHILD_HOME_NO_CHILD', EMPTY_PARAMETERS);
    }
    CHILD_HOME_NO_CHILD_HINT() {
        return this.translator.translate('CHILD_HOME_NO_CHILD_HINT', EMPTY_PARAMETERS);
    }
    CHILD_HOME_PLAY() {
        return this.translator.translate('CHILD_HOME_PLAY', EMPTY_PARAMETERS);
    }
    CHILD_HOME_QUESTS_FAILED() {
        return this.translator.translate('CHILD_HOME_QUESTS_FAILED', EMPTY_PARAMETERS);
    }
    CHILD_HOME_QUESTS_LOADING() {
        return this.translator.translate('CHILD_HOME_QUESTS_LOADING', EMPTY_PARAMETERS);
    }
    CHILD_INTEREST(interest) {
        return this.translator.translate('CHILD_INTEREST', { interest });
    }
    CHILD_LEARNING(learning) {
        return this.translator.translate('CHILD_LEARNING', { learning });
    }
    CHILD_NO_NAME() {
        return this.translator.translate('CHILD_NO_NAME', EMPTY_PARAMETERS);
    }
    CHILD_QUESTS_FAILED() {
        return this.translator.translate('CHILD_QUESTS_FAILED', EMPTY_PARAMETERS);
    }
    CHILD_QUEST_LINE(level, world, host) {
        return this.translator.translate('CHILD_QUEST_LINE', { level, world, host });
    }
    FAMILY_LOADING() {
        return this.translator.translate('FAMILY_LOADING', EMPTY_PARAMETERS);
    }
    FAMILY_LOAD_FAILED() {
        return this.translator.translate('FAMILY_LOAD_FAILED', EMPTY_PARAMETERS);
    }
    FAMILY_TRY_AGAIN() {
        return this.translator.translate('FAMILY_TRY_AGAIN', EMPTY_PARAMETERS);
    }
    FREE_TIME_OPTION_AFTER_SCHOOL() {
        return this.translator.translate('FREE_TIME_OPTION_AFTER_SCHOOL', EMPTY_PARAMETERS);
    }
    FREE_TIME_OPTION_BEFORE_DINNER() {
        return this.translator.translate('FREE_TIME_OPTION_BEFORE_DINNER', EMPTY_PARAMETERS);
    }
    FREE_TIME_OPTION_IN_THE_EVENING() {
        return this.translator.translate('FREE_TIME_OPTION_IN_THE_EVENING', EMPTY_PARAMETERS);
    }
    FREE_TIME_OPTION_ON_WEEKENDS() {
        return this.translator.translate('FREE_TIME_OPTION_ON_WEEKENDS', EMPTY_PARAMETERS);
    }
    GETTING_STARTED(children) {
        return this.translator.translateWithChildren('GETTING_STARTED', EMPTY_PARAMETERS, children);
    }
    INTEREST_GROUP_ANIMALS() {
        return this.translator.translate('INTEREST_GROUP_ANIMALS', EMPTY_PARAMETERS);
    }
    INTEREST_GROUP_MAKE_BELIEVE() {
        return this.translator.translate('INTEREST_GROUP_MAKE_BELIEVE', EMPTY_PARAMETERS);
    }
    INTEREST_GROUP_MAKING_AND_PLAYING() {
        return this.translator.translate('INTEREST_GROUP_MAKING_AND_PLAYING', EMPTY_PARAMETERS);
    }
    INTEREST_GROUP_SCIENCE() {
        return this.translator.translate('INTEREST_GROUP_SCIENCE', EMPTY_PARAMETERS);
    }
    INTEREST_GROUP_SPORTS() {
        return this.translator.translate('INTEREST_GROUP_SPORTS', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_BASKETBALL() {
        return this.translator.translate('INTEREST_OPTION_BASKETBALL', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_CATS_AND_KITTENS() {
        return this.translator.translate('INTEREST_OPTION_CATS_AND_KITTENS', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_DANCE() {
        return this.translator.translate('INTEREST_OPTION_DANCE', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_DINOSAURS() {
        return this.translator.translate('INTEREST_OPTION_DINOSAURS', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_DOGS_AND_PUPPIES() {
        return this.translator.translate('INTEREST_OPTION_DOGS_AND_PUPPIES', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_DRAWING_AND_PAINTING() {
        return this.translator.translate('INTEREST_OPTION_DRAWING_AND_PAINTING', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_FARM_AND_TRACTORS() {
        return this.translator.translate('INTEREST_OPTION_FARM_AND_TRACTORS', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_FOOTBALL() {
        return this.translator.translate('INTEREST_OPTION_FOOTBALL', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_GYMNASTICS() {
        return this.translator.translate('INTEREST_OPTION_GYMNASTICS', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_PRINCESSES_AND_CASTLES() {
        return this.translator.translate('INTEREST_OPTION_PRINCESSES_AND_CASTLES', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_SCIENCE_EXPERIMENTS() {
        return this.translator.translate('INTEREST_OPTION_SCIENCE_EXPERIMENTS', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_SOCCER() {
        return this.translator.translate('INTEREST_OPTION_SOCCER', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_VIDEO_GAMES() {
        return this.translator.translate('INTEREST_OPTION_VIDEO_GAMES', EMPTY_PARAMETERS);
    }
    INTEREST_OPTION_VOLCANOES() {
        return this.translator.translate('INTEREST_OPTION_VOLCANOES', EMPTY_PARAMETERS);
    }
    LANDING_BAND_TITLE() {
        return this.translator.translate('LANDING_BAND_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_CALL_TO_ACTION() {
        return this.translator.translate('LANDING_CALL_TO_ACTION', EMPTY_PARAMETERS);
    }
    LANDING_CALL_TO_ACTION_NOTE() {
        return this.translator.translate('LANDING_CALL_TO_ACTION_NOTE', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_ALONE_ANSWER() {
        return this.translator.translate('LANDING_FAQ_ALONE_ANSWER', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_ALONE_QUESTION() {
        return this.translator.translate('LANDING_FAQ_ALONE_QUESTION', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_COST_ANSWER() {
        return this.translator.translate('LANDING_FAQ_COST_ANSWER', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_COST_QUESTION() {
        return this.translator.translate('LANDING_FAQ_COST_QUESTION', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_LENGTH_ANSWER() {
        return this.translator.translate('LANDING_FAQ_LENGTH_ANSWER', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_LENGTH_QUESTION() {
        return this.translator.translate('LANDING_FAQ_LENGTH_QUESTION', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_NEEDS_ANSWER() {
        return this.translator.translate('LANDING_FAQ_NEEDS_ANSWER', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_NEEDS_QUESTION() {
        return this.translator.translate('LANDING_FAQ_NEEDS_QUESTION', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_SCREEN_ANSWER() {
        return this.translator.translate('LANDING_FAQ_SCREEN_ANSWER', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_SCREEN_QUESTION() {
        return this.translator.translate('LANDING_FAQ_SCREEN_QUESTION', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_START_ANSWER() {
        return this.translator.translate('LANDING_FAQ_START_ANSWER', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_START_QUESTION() {
        return this.translator.translate('LANDING_FAQ_START_QUESTION', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_TITLE() {
        return this.translator.translate('LANDING_FAQ_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_WHO_ANSWER() {
        return this.translator.translate('LANDING_FAQ_WHO_ANSWER', EMPTY_PARAMETERS);
    }
    LANDING_FAQ_WHO_QUESTION() {
        return this.translator.translate('LANDING_FAQ_WHO_QUESTION', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_FIT_LINE() {
        return this.translator.translate('LANDING_FEATURE_FIT_LINE', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_FIT_TITLE() {
        return this.translator.translate('LANDING_FEATURE_FIT_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_HELP_LINE() {
        return this.translator.translate('LANDING_FEATURE_HELP_LINE', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_HELP_TITLE() {
        return this.translator.translate('LANDING_FEATURE_HELP_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_LOOP_LINE() {
        return this.translator.translate('LANDING_FEATURE_LOOP_LINE', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_LOOP_TITLE() {
        return this.translator.translate('LANDING_FEATURE_LOOP_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_SHORT_LINE() {
        return this.translator.translate('LANDING_FEATURE_SHORT_LINE', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_SHORT_TITLE() {
        return this.translator.translate('LANDING_FEATURE_SHORT_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_WORLD_LINE() {
        return this.translator.translate('LANDING_FEATURE_WORLD_LINE', EMPTY_PARAMETERS);
    }
    LANDING_FEATURE_WORLD_TITLE() {
        return this.translator.translate('LANDING_FEATURE_WORLD_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_FOOTER() {
        return this.translator.translate('LANDING_FOOTER', EMPTY_PARAMETERS);
    }
    LANDING_HERO_SUBTITLE_FIRST_LINE() {
        return this.translator.translate('LANDING_HERO_SUBTITLE_FIRST_LINE', EMPTY_PARAMETERS);
    }
    LANDING_HERO_SUBTITLE_SECOND_LINE() {
        return this.translator.translate('LANDING_HERO_SUBTITLE_SECOND_LINE', EMPTY_PARAMETERS);
    }
    LANDING_HERO_TITLE_END() {
        return this.translator.translate('LANDING_HERO_TITLE_END', EMPTY_PARAMETERS);
    }
    LANDING_HERO_TITLE_FIRST_LINE() {
        return this.translator.translate('LANDING_HERO_TITLE_FIRST_LINE', EMPTY_PARAMETERS);
    }
    LANDING_HERO_TITLE_HIGHLIGHT() {
        return this.translator.translate('LANDING_HERO_TITLE_HIGHLIGHT', EMPTY_PARAMETERS);
    }
    LANDING_HERO_TITLE_LEAD() {
        return this.translator.translate('LANDING_HERO_TITLE_LEAD', EMPTY_PARAMETERS);
    }
    LANDING_HOW_TITLE() {
        return this.translator.translate('LANDING_HOW_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_LESSONS_TITLE() {
        return this.translator.translate('LANDING_LESSONS_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_PANEL_TITLE() {
        return this.translator.translate('LANDING_PANEL_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_PICTURE_ARENA() {
        return this.translator.translate('LANDING_PICTURE_ARENA', EMPTY_PARAMETERS);
    }
    LANDING_PICTURE_BANANA_PEEL() {
        return this.translator.translate('LANDING_PICTURE_BANANA_PEEL', EMPTY_PARAMETERS);
    }
    LANDING_PICTURE_BASKETBALL_QUESTION() {
        return this.translator.translate('LANDING_PICTURE_BASKETBALL_QUESTION', EMPTY_PARAMETERS);
    }
    LANDING_PICTURE_COACH_SAM() {
        return this.translator.translate('LANDING_PICTURE_COACH_SAM', EMPTY_PARAMETERS);
    }
    LANDING_PICTURE_FAMILY() {
        return this.translator.translate('LANDING_PICTURE_FAMILY', EMPTY_PARAMETERS);
    }
    LANDING_PICTURE_HERO() {
        return this.translator.translate('LANDING_PICTURE_HERO', EMPTY_PARAMETERS);
    }
    LANDING_PLAY_ACTION() {
        return this.translator.translate('LANDING_PLAY_ACTION', EMPTY_PARAMETERS);
    }
    LANDING_PLAY_LINE() {
        return this.translator.translate('LANDING_PLAY_LINE', EMPTY_PARAMETERS);
    }
    LANDING_PLAY_TITLE() {
        return this.translator.translate('LANDING_PLAY_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_CHALLENGE_CITATION() {
        return this.translator.translate('LANDING_RESEARCH_CHALLENGE_CITATION', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_CHALLENGE_LINE() {
        return this.translator.translate('LANDING_RESEARCH_CHALLENGE_LINE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_CHALLENGE_TITLE() {
        return this.translator.translate('LANDING_RESEARCH_CHALLENGE_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_CHOICE_CITATION() {
        return this.translator.translate('LANDING_RESEARCH_CHOICE_CITATION', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_CHOICE_LINE() {
        return this.translator.translate('LANDING_RESEARCH_CHOICE_LINE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_CHOICE_TITLE() {
        return this.translator.translate('LANDING_RESEARCH_CHOICE_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_INTEREST_CITATION() {
        return this.translator.translate('LANDING_RESEARCH_INTEREST_CITATION', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_INTEREST_LINE() {
        return this.translator.translate('LANDING_RESEARCH_INTEREST_LINE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_INTEREST_TITLE() {
        return this.translator.translate('LANDING_RESEARCH_INTEREST_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_NOTE() {
        return this.translator.translate('LANDING_RESEARCH_NOTE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_OFTEN_CITATION() {
        return this.translator.translate('LANDING_RESEARCH_OFTEN_CITATION', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_OFTEN_LINE() {
        return this.translator.translate('LANDING_RESEARCH_OFTEN_LINE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_OFTEN_TITLE() {
        return this.translator.translate('LANDING_RESEARCH_OFTEN_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_RESEARCH_TITLE() {
        return this.translator.translate('LANDING_RESEARCH_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_SEE_LESSON() {
        return this.translator.translate('LANDING_SEE_LESSON', EMPTY_PARAMETERS);
    }
    LANDING_STATEMENT_FIRST_LINE() {
        return this.translator.translate('LANDING_STATEMENT_FIRST_LINE', EMPTY_PARAMETERS);
    }
    LANDING_STATEMENT_SECOND_LINE() {
        return this.translator.translate('LANDING_STATEMENT_SECOND_LINE', EMPTY_PARAMETERS);
    }
    LANDING_STEP_1_LINE_1() {
        return this.translator.translate('LANDING_STEP_1_LINE_1', EMPTY_PARAMETERS);
    }
    LANDING_STEP_1_LINE_2() {
        return this.translator.translate('LANDING_STEP_1_LINE_2', EMPTY_PARAMETERS);
    }
    LANDING_STEP_1_TITLE() {
        return this.translator.translate('LANDING_STEP_1_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_STEP_2_LINE_1() {
        return this.translator.translate('LANDING_STEP_2_LINE_1', EMPTY_PARAMETERS);
    }
    LANDING_STEP_2_LINE_2() {
        return this.translator.translate('LANDING_STEP_2_LINE_2', EMPTY_PARAMETERS);
    }
    LANDING_STEP_2_LINE_3() {
        return this.translator.translate('LANDING_STEP_2_LINE_3', EMPTY_PARAMETERS);
    }
    LANDING_STEP_2_TITLE() {
        return this.translator.translate('LANDING_STEP_2_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_STEP_3_LINE_1() {
        return this.translator.translate('LANDING_STEP_3_LINE_1', EMPTY_PARAMETERS);
    }
    LANDING_STEP_3_LINE_2() {
        return this.translator.translate('LANDING_STEP_3_LINE_2', EMPTY_PARAMETERS);
    }
    LANDING_STEP_3_LINE_3() {
        return this.translator.translate('LANDING_STEP_3_LINE_3', EMPTY_PARAMETERS);
    }
    LANDING_STEP_3_TITLE() {
        return this.translator.translate('LANDING_STEP_3_TITLE', EMPTY_PARAMETERS);
    }
    LANDING_STORY_MASON_LABEL() {
        return this.translator.translate('LANDING_STORY_MASON_LABEL', EMPTY_PARAMETERS);
    }
    LANDING_STORY_MASON_TEXT() {
        return this.translator.translate('LANDING_STORY_MASON_TEXT', EMPTY_PARAMETERS);
    }
    LANDING_STORY_STUCK_LABEL() {
        return this.translator.translate('LANDING_STORY_STUCK_LABEL', EMPTY_PARAMETERS);
    }
    LANDING_STORY_STUCK_TEXT() {
        return this.translator.translate('LANDING_STORY_STUCK_TEXT', EMPTY_PARAMETERS);
    }
    LEARNING_OPTION_EARLY_MATH() {
        return this.translator.translate('LEARNING_OPTION_EARLY_MATH', EMPTY_PARAMETERS);
    }
    LEARNING_OPTION_LEARNING_TO_READ() {
        return this.translator.translate('LEARNING_OPTION_LEARNING_TO_READ', EMPTY_PARAMETERS);
    }
    LEARNING_OPTION_MATH_READY_FOR_MORE() {
        return this.translator.translate('LEARNING_OPTION_MATH_READY_FOR_MORE', EMPTY_PARAMETERS);
    }
    LEARNING_OPTION_READING_READY_FOR_MORE() {
        return this.translator.translate('LEARNING_OPTION_READING_READY_FOR_MORE', EMPTY_PARAMETERS);
    }
    LEARNING_OPTION_READING_WITH_CONFIDENCE() {
        return this.translator.translate('LEARNING_OPTION_READING_WITH_CONFIDENCE', EMPTY_PARAMETERS);
    }
    LEARNING_OPTION_TIMES_TABLES() {
        return this.translator.translate('LEARNING_OPTION_TIMES_TABLES', EMPTY_PARAMETERS);
    }
    LESSONS_LOGIN_HINT() {
        return this.translator.translate('LESSONS_LOGIN_HINT', EMPTY_PARAMETERS);
    }
    LESSONS_LOGIN_TITLE() {
        return this.translator.translate('LESSONS_LOGIN_TITLE', EMPTY_PARAMETERS);
    }
    LESSONS_NEXT_STEP_OPEN() {
        return this.translator.translate('LESSONS_NEXT_STEP_OPEN', EMPTY_PARAMETERS);
    }
    LESSONS_NEXT_STEP_SIGN_IN(email) {
        return this.translator.translate('LESSONS_NEXT_STEP_SIGN_IN', { email });
    }
    LESSONS_NEXT_STEP_TITLE() {
        return this.translator.translate('LESSONS_NEXT_STEP_TITLE', EMPTY_PARAMETERS);
    }
    LOGIN_CHANGE_EMAIL() {
        return this.translator.translate('LOGIN_CHANGE_EMAIL', EMPTY_PARAMETERS);
    }
    LOGIN_CODE_LABEL() {
        return this.translator.translate('LOGIN_CODE_LABEL', EMPTY_PARAMETERS);
    }
    LOGIN_CODE_SENT(email) {
        return this.translator.translate('LOGIN_CODE_SENT', { email });
    }
    LOGIN_EMAIL_LABEL() {
        return this.translator.translate('LOGIN_EMAIL_LABEL', EMPTY_PARAMETERS);
    }
    LOGIN_FAILURE_ACCOUNT_CONFLICT() {
        return this.translator.translate('LOGIN_FAILURE_ACCOUNT_CONFLICT', EMPTY_PARAMETERS);
    }
    LOGIN_FAILURE_CODE_EXPIRED() {
        return this.translator.translate('LOGIN_FAILURE_CODE_EXPIRED', EMPTY_PARAMETERS);
    }
    LOGIN_FAILURE_GOOGLE_REFUSED() {
        return this.translator.translate('LOGIN_FAILURE_GOOGLE_REFUSED', EMPTY_PARAMETERS);
    }
    LOGIN_FAILURE_INVALID_EMAIL() {
        return this.translator.translate('LOGIN_FAILURE_INVALID_EMAIL', EMPTY_PARAMETERS);
    }
    LOGIN_FAILURE_TOO_MANY_REQUESTS() {
        return this.translator.translate('LOGIN_FAILURE_TOO_MANY_REQUESTS', EMPTY_PARAMETERS);
    }
    LOGIN_FAILURE_UNAVAILABLE() {
        return this.translator.translate('LOGIN_FAILURE_UNAVAILABLE', EMPTY_PARAMETERS);
    }
    LOGIN_FAILURE_WRONG_CODE() {
        return this.translator.translate('LOGIN_FAILURE_WRONG_CODE', EMPTY_PARAMETERS);
    }
    LOGIN_OR() {
        return this.translator.translate('LOGIN_OR', EMPTY_PARAMETERS);
    }
    LOGIN_SEND_CODE() {
        return this.translator.translate('LOGIN_SEND_CODE', EMPTY_PARAMETERS);
    }
    LOGIN_SEND_NEW_CODE() {
        return this.translator.translate('LOGIN_SEND_NEW_CODE', EMPTY_PARAMETERS);
    }
    LOGIN_TITLE() {
        return this.translator.translate('LOGIN_TITLE', EMPTY_PARAMETERS);
    }
    LOGIN_VERIFY() {
        return this.translator.translate('LOGIN_VERIFY', EMPTY_PARAMETERS);
    }
    LOGO_LABEL() {
        return this.translator.translate('LOGO_LABEL', EMPTY_PARAMETERS);
    }
    PLAY_BACK_HOME() {
        return this.translator.translate('PLAY_BACK_HOME', EMPTY_PARAMETERS);
    }
    PLAY_FINAL_ROUND() {
        return this.translator.translate('PLAY_FINAL_ROUND', EMPTY_PARAMETERS);
    }
    PLAY_FINAL_SHORT() {
        return this.translator.translate('PLAY_FINAL_SHORT', EMPTY_PARAMETERS);
    }
    PLAY_LADDER_LABEL() {
        return this.translator.translate('PLAY_LADDER_LABEL', EMPTY_PARAMETERS);
    }
    PLAY_LESSON_DONE() {
        return this.translator.translate('PLAY_LESSON_DONE', EMPTY_PARAMETERS);
    }
    PLAY_LESSON_PROGRESS(finished, total) {
        return this.translator.translate('PLAY_LESSON_PROGRESS', { finished, total });
    }
    PLAY_LETS_GO() {
        return this.translator.translate('PLAY_LETS_GO', EMPTY_PARAMETERS);
    }
    PLAY_LEVEL(number, name) {
        return this.translator.translate('PLAY_LEVEL', { number, name });
    }
    PLAY_LEVELS_SPAN(count, first) {
        return this.translator.translate('PLAY_LEVELS_SPAN', { count, first });
    }
    PLAY_LEVEL_DONE(number) {
        return this.translator.translate('PLAY_LEVEL_DONE', { number });
    }
    PLAY_NEXT() {
        return this.translator.translate('PLAY_NEXT', EMPTY_PARAMETERS);
    }
    PLAY_POINTS_WON(points) {
        return this.translator.translate('PLAY_POINTS_WON', { points });
    }
    PLAY_QUESTION_PROGRESS(current, count) {
        return this.translator.translate('PLAY_QUESTION_PROGRESS', { current, count });
    }
    PLAY_SAY_AGAIN() {
        return this.translator.translate('PLAY_SAY_AGAIN', EMPTY_PARAMETERS);
    }
    PLAY_SCORE(score) {
        return this.translator.translate('PLAY_SCORE', { score });
    }
    PLAY_SCORE_SHORT(score) {
        return this.translator.translate('PLAY_SCORE_SHORT', { score });
    }
    PLAY_STARTING() {
        return this.translator.translate('PLAY_STARTING', EMPTY_PARAMETERS);
    }
    PLAY_START_FAILED() {
        return this.translator.translate('PLAY_START_FAILED', EMPTY_PARAMETERS);
    }
    PLAY_TAP_TO_PLAY() {
        return this.translator.translate('PLAY_TAP_TO_PLAY', EMPTY_PARAMETERS);
    }
    PLAY_TURN_SOUND_ON() {
        return this.translator.translate('PLAY_TURN_SOUND_ON', EMPTY_PARAMETERS);
    }
    PLAY_VERSUS(opponent) {
        return this.translator.translate('PLAY_VERSUS', { opponent });
    }
    PLAY_WORLD_WITH_HOST(world, host) {
        return this.translator.translate('PLAY_WORLD_WITH_HOST', { world, host });
    }
    QUEST_LEVEL_MATH_9_HARD_HALF() {
        return this.translator.translate('QUEST_LEVEL_MATH_9_HARD_HALF', EMPTY_PARAMETERS);
    }
    QUEST_LEVEL_MATH_9_START() {
        return this.translator.translate('QUEST_LEVEL_MATH_9_START', EMPTY_PARAMETERS);
    }
    REMOVE_CHILD() {
        return this.translator.translate('REMOVE_CHILD', EMPTY_PARAMETERS);
    }
    REMOVE_CHILD_CANCEL() {
        return this.translator.translate('REMOVE_CHILD_CANCEL', EMPTY_PARAMETERS);
    }
    REMOVE_CHILD_CONFIRM(name) {
        return this.translator.translate('REMOVE_CHILD_CONFIRM', { name });
    }
    REMOVE_CHILD_CONFIRM_NO_NAME() {
        return this.translator.translate('REMOVE_CHILD_CONFIRM_NO_NAME', EMPTY_PARAMETERS);
    }
    REMOVE_CHILD_FAILED() {
        return this.translator.translate('REMOVE_CHILD_FAILED', EMPTY_PARAMETERS);
    }
    REMOVE_CHILD_YES() {
        return this.translator.translate('REMOVE_CHILD_YES', EMPTY_PARAMETERS);
    }
    SESSION_RESTORING() {
        return this.translator.translate('SESSION_RESTORING', EMPTY_PARAMETERS);
    }
    SIGNED_IN_AS(email) {
        return this.translator.translate('SIGNED_IN_AS', { email });
    }
    SIGN_OUT() {
        return this.translator.translate('SIGN_OUT', EMPTY_PARAMETERS);
    }
    START_DEMO() {
        return this.translator.translate('START_DEMO', EMPTY_PARAMETERS);
    }
    WORLD_HOOPS() {
        return this.translator.translate('WORLD_HOOPS', EMPTY_PARAMETERS);
    }
    WORLD_HOOPS_HOST() {
        return this.translator.translate('WORLD_HOOPS_HOST', EMPTY_PARAMETERS);
    }
    WORLD_HOOPS_OPPONENT_1() {
        return this.translator.translate('WORLD_HOOPS_OPPONENT_1', EMPTY_PARAMETERS);
    }
    WORLD_HOOPS_OPPONENT_2() {
        return this.translator.translate('WORLD_HOOPS_OPPONENT_2', EMPTY_PARAMETERS);
    }
    WORLD_HOOPS_OPPONENT_3() {
        return this.translator.translate('WORLD_HOOPS_OPPONENT_3', EMPTY_PARAMETERS);
    }
    WORLD_HOOPS_OPPONENT_4() {
        return this.translator.translate('WORLD_HOOPS_OPPONENT_4', EMPTY_PARAMETERS);
    }
    WORLD_HOOPS_OPPONENT_5() {
        return this.translator.translate('WORLD_HOOPS_OPPONENT_5', EMPTY_PARAMETERS);
    }
    WORLD_HOOPS_OPPONENT_6() {
        return this.translator.translate('WORLD_HOOPS_OPPONENT_6', EMPTY_PARAMETERS);
    }
}
//# sourceMappingURL=Messages.js.map